import { FilterTypes } from '../enums/filterTypes';
import { FilterDateOptions } from '../enums/filter/filterDateOptions';

export class EmployeeCardShowingFilter {
  filterType: FilterTypes;
  filterDateOption: FilterDateOptions;
}
